import React, { useContext, useEffect, useState } from 'react'
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal'

import { useNavigate } from 'react-router-dom'

import BackEndAPI from '../../../Services/BackEndAPI'
import { MensagemTipo } from '../../../GlobalStates/MensagemState'

import { Box, Button, Container, Grid, IconButton, Paper, Tab, Tabs, Typography } from '@mui/material'

import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'
import TextArea from '../../../DevComponents/TextArea'
import { RespostaPadraoInterface } from '../../../ImportBackend/Interfaces/PadraoInterfaces'
import Condicional from '../../../Layout/Condicional'

import { clsUtils } from 'zlib-utils'
import { FatorRHJSONInterface } from '../../../ImportBackend/Interfaces/FatorRHInterfaces'

export default function FatorRHCadastroJSON() {

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto

  const navigate = useNavigate()

  const ResetDados: FatorRHJSONInterface = {
    jsonAdmissao: '',
    jsonAfastamento: '',
    jsonDemissao: ''
  }

  const [dados, setDados] = useState<typeof ResetDados>({ ...ResetDados })
  const [conteudoOriginal, setConteudoOriginal] = useState<FatorRHJSONInterface>({ ...ResetDados })

  const clsApi: BackEndAPI = new BackEndAPI()

  const onChangeTipoRH = () => {

    const query = `
        getFatorRHJson  {
          jsonAfastamento
          jsonAdmissao
          jsonDemissao
        }
      `

    clsApi.query<FatorRHJSONInterface>(query, 'getFatorRHJson', 'Consultando JSON...', contexto).then(rsJSON => {

      setDados(rsJSON)
      setConteudoOriginal(rsJSON)

    }).catch(() => {

      setDados(ResetDados)

      setMensagemState({
        ...mensagemState,
        titulo: 'Erro! Consulte Suporte!',
        exibir: true,
        mensagem: 'Erro ao consultar JSON do Fator RH!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      })

    })

  }

  const onGravarJSON = () => {

    const mutation = `
        updateFatorRHJson (dados: ${clsUtils.ConverterEmGql(dados)}) {
          ok
          mensagem
        }
      `

    console.log(mutation)

    clsApi.mutation<RespostaPadraoInterface>(mutation, 'updateFatorRHJson', 'Atualizando JSON...', contexto).then(rsJSON => {

      if (!rsJSON.ok) {
        setMensagemState({
          ...mensagemState,
          titulo: 'Erro ao atualizar JSON do Fator RH!',
          exibir: true,
          mensagem: rsJSON.mensagem,
          tipo: MensagemTipo.Error,
          exibirBotao: true
        })

      } else {
        setConteudoOriginal(dados)
      }


    }).catch(() => {

      setMensagemState({
        ...mensagemState,
        titulo: 'Erro! Consulte Suporte!',
        exibir: true,
        mensagem: 'Erro ao atualizar JSON do Fator RH!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      })

    })

  }

  const [rsTab, setRsTab] = useState(0)

  const changeRsTab = (_event: React.SyntheticEvent, newValue: number) => {
    setRsTab(newValue)
  }

  useEffect(() => {
    onChangeTipoRH()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (

    <>

      <Container maxWidth="md" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>

          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>

              <Typography component="h5" variant="h5" align="left">
                Cadastro JSON Fator RH
                <Typography variant="body2" gutterBottom>
                  Cadastro do JSON para geração do Fator RH por tipo de RH
                </Typography>
              </Typography>

              <IconButton onClick={() => navigate('/')}>
                <CloseIcon />
              </IconButton>

            </Grid>

            <Grid item xs={12}>

              <Box sx={{ width: '100%' }}>

                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs value={rsTab} onChange={changeRsTab} aria-label="fatorrh envio tabs">
                    <Tab label="Admissão" />
                    <Tab label="Afastamento" />
                    <Tab label="Demissão" />
                  </Tabs>
                </Box>

                <Condicional condicao={rsTab === 0}>
                  <TextArea
                    dados={dados}
                    field='jsonAdmissao'
                    label='JSON Admissão'
                    setState={setDados}
                    height='300px'
                  />
                </Condicional>

                <Condicional condicao={rsTab === 1}>
                  <TextArea
                    dados={dados}
                    field='jsonAfastamento'
                    label='JSON Afastamento'
                    setState={setDados}
                    height='300px'
                  />
                </Condicional>

                <Condicional condicao={rsTab === 2}>
                  <TextArea
                    dados={dados}
                    field='jsonDemissao'
                    label='JSON Demissão'
                    setState={setDados}
                    height='300px'
                  />
                </Condicional>

              </Box>

            </Grid>

            <Grid item xs={12} sx={{ mt: 1, textAlign: 'right' }} >
              <Button disabled={JSON.stringify(dados) !== JSON.stringify(conteudoOriginal) ? false : true} variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => onGravarJSON()}>Gravar</Button>
            </Grid>

          </Grid>
        </Paper>
      </Container>

    </>

  )
}